import React, { useState } from 'react';
import { fetchVariableList } from '@/slices/panelSlice/variableListSlice';
import { useDispatch } from 'react-redux';
import api from '@/auth/api';
import { alertError, alertSuccess } from '@/components/Alert';

// Move these outside the component
const Input = ({ name, placeholder, type = 'text', value, onChange }) => (
  <input
    type={type}
    name={name}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    className="w-full border px-3 py-2 rounded"
    required
  />
);

const Select = ({ name, placeholder, options = [], value, onChange }) => (
  <select
    name={name}
    value={value}
    onChange={onChange}
    className="w-full border px-3 py-2 rounded"
    required
  >
    <option value="">{placeholder}</option>
    {options.map((item) => (
      <option key={item.id} value={item.id}>{item.title}</option>
    ))}
  </select>
);

function AddVariable({ vTypeData = [], categoryData = [], subCategoryData = [] }) {
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    title: '',
    questionTitle: '',
    subTitle: '',
    comment: '',
    variableType: '',
    category: '',
    subCategory: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      title: formData.title,
      variableType: Number(formData.variableType),
      category: Number(formData.category),
      subCategory: Number(formData.subCategory),
      comment: formData.comment,
      QuestionTitle: {
        title: formData.questionTitle,
        subTitle: formData.subTitle,
        titleTranslate: {
          English: formData.questionTitle,
        },
        subTitleTranslate: {
          English: formData.subTitle,
        },
      },
    };

    // console.log('Payload:', payload);
    try{
        const resp = await api.post('/panel/PanelVariableMap',payload);
        alertSuccess(resp?.data?.success);
        dispatch(fetchVariableList())
    }catch(err){
        alertError(err?.response?.data?.errors);
    }
  };

  return (
    <div className="p-4 border rounded max-w-3xl mx-auto bg-white shadow">
      <form onSubmit={handleSubmit} className="space-y-4">
        <div className="flex gap-4">
          <Input name="title" placeholder="Variable Title" value={formData.title} onChange={handleChange} />
          <Input name="comment" placeholder="Comment" value={formData.comment} onChange={handleChange} />
        </div>

        <div className="flex gap-4">
          <Input name="questionTitle" placeholder="Question Title" value={formData.questionTitle} onChange={handleChange} />
          <Input name="subTitle" placeholder="Sub Title" value={formData.subTitle} onChange={handleChange} />
        </div>

        <div className="flex gap-4">
          <Select
            name="variableType"
            placeholder="Select Variable Type"
            options={vTypeData?.result || []}
            value={formData.variableType}
            onChange={handleChange}
          />
          <Select
            name="category"
            placeholder="Select Category"
            options={categoryData?.result || []}
            value={formData.category}
            onChange={handleChange}
          />
        </div>

        <div className="flex gap-4">
          <Select
            name="subCategory"
            placeholder="Select Sub Category"
            options={subCategoryData?.result || []}
            value={formData.subCategory}
            onChange={handleChange}
          />
          <div className="w-full" />
        </div>

        <div className="flex justify-end">
          <button type="submit" className="bg-blue-600 text-white px-6 py-2 rounded hover:bg-blue-700">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
}

export default AddVariable;
